export default "__VITE_ASSET__BDA5wrFt__"